import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-395970d5"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://shop.geospatial.com/"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "page-title exo"
}, "GEOSPATIAL PRODUCTS", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-box"
}, [/*#__PURE__*/_createElementVNode("span", null, "PRODUCTS›")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_input = _resolveComponent("search-input");
  const _component_el_card = _resolveComponent("el-card");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, {
    class: "home-container",
    direction: "vertical"
  }, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_Teleport, {
      to: "head"
    }, [_hoisted_1])), _hoisted_2, _createVNode(_component_search_input), _createVNode(_component_el_row, {
      class: "v-spaced"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsCategory, (cat, idx) => {
        return _openBlock(), _createBlock(_component_el_col, {
          class: "col-centered",
          lg: 8,
          md: 12,
          sm: 12,
          xs: 24,
          key: idx
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'byType',
              params: {
                slug: cat.path
              }
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, {
              class: "c-card",
              style: _normalizeStyle([{
                "display": "flex",
                "align-items": "center",
                "justify-content": "center"
              }, {
                backgroundImage: 'url(' + cat.image + ')',
                backgroundColor: cat.color
              }])
            }, {
              default: _withCtx(() => [_createElementVNode("h5", null, _toDisplayString(cat.title), 1), _hoisted_3]),
              _: 2
            }, 1032, ["style"])]),
            _: 2
          }, 1032, ["to"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  });
}